














































































import { Component, Vue, Watch } from 'vue-property-decorator'
import AlertModule, { semTags } from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { chatDeSuporteConfigurado } from '@/api/suporteChat'
import { contextoDaTela, falarComOSuporteSobreOErro } from '@/store/vuex/suporte/ChatDeSuporteStore'
import { falhaAoAnexarErro } from '@/shareds/chat-de-suporte'

@Component
export default class AppAlert extends Vue {
	showDetails = false
	falandoComOSuporte = false
	falhaAoFalarComOSuporte: string | null = null

	set show(value: boolean) {
		AlertModule.setShow(value)
	}

	get show() {
		return AlertModule.show
	}

	get message() {
		return AlertModule.message
	}

	/** Erro com código do log interno, usuário logado e chat no ambiente (no cadastro de conta não há chat). */
	get podeFalarComOSuporte() {
		return !!this.message.codigo && !!UserLoginStore.usuario && chatDeSuporteConfigurado()
	}

	@Watch('message')
	aoTrocarDeMensagem() {
		this.falhaAoFalarComOSuporte = null
	}

	/**
	 * O erro vai ao suporte em segundo plano: o backend do ERP o registra pelo código, e o chat abre com ele anexado.
	 * A pessoa não vê os detalhes técnicos na conversa, só o texto padrão do suporte como mensagem dela.
	 */
	async falarComOSuporte() {
		const codigo = this.message.codigo
		if (!codigo || this.falandoComOSuporte) return
		this.falandoComOSuporte = true
		this.falhaAoFalarComOSuporte = null
		try {
			await falarComOSuporteSobreOErro(codigo, semTags(this.message.text), contextoDaTela(this.$route))
			this.showDetails = false
			this.show = false
		} catch (erro) {
			const status = (erro as { response?: { status?: number } } | null)?.response?.status
			this.falhaAoFalarComOSuporte = falhaAoAnexarErro(status)
		} finally {
			this.falandoComOSuporte = false
		}
	}

	@Watch('show')
	onShow(show: boolean) {
		show
			? document.addEventListener('keydown', this.atalhoDeSumir)
			: document.removeEventListener('keydown', this.atalhoDeSumir)
	}

	atalhoDeSumir(event: KeyboardEvent) {
		if (event.key !== 'Escape') return
		if (this.show) this.show = false
		event.preventDefault()
		event.stopPropagation()
	}
}

